if (!customElements.get('baretren-video')) {
  customElements.define('baretren-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('.bt-video-play');
      if (!this.video || !this.button) return;
      this.initialized = true;
      this.video.autoplay = false;
      this.video.loop = false;
      this.video.muted = false;
      this.button.hidden = false;
      this.button.addEventListener('click', () => {
        this.video.muted = false;
        this.video.play().then(() => {
          this.button.hidden = true;
          this.video.focus({ preventScroll: true });
        }).catch(() => {
          this.button.hidden = true;
          this.video.controls = true;
          this.video.focus({ preventScroll: true });
        });
      });
      this.video.addEventListener('play', () => { this.button.hidden = true; });
      this.video.addEventListener('ended', () => { this.button.hidden = false; });
    }
    disconnectedCallback() {
      this.video?.pause();
    }
  });
}
